import { PrinterOutlined } from '@ant-design/icons';
import { Button, InputNumber, Modal, Typography } from 'antd';
import React from 'react'
import AttestationCEDEAOToPrint from '../../components/docs/AttestationCEDEAOToPrint';
import AttestationCEDEAO from '../../components/docs/AttestationCEDEAO';

const { Title } = Typography;

const ImprimerAttestationCEDEAO = ({
    modalCEDEAOAttOpen,
    setModalCEDEAOAttOpen,
    contrat,
    printedCEDEAOAttestation,
    printingCEDEAOAttestation,
    printingDamagedCEDEAOAttestation,
    setPrintingCEDEAOAttestation,
    numeroAttestation,
    setNumeroAttestation,
    attestationCEDEAOPrinting,
    attestationCEDEAONonPrintedPrinting,
    attestationCEDEAODamagedPrinting,
    attestationDamaged,
    setAttestationDamaged,
    regle,
    rightsService,
    onTabsChange
}) => {
    const secondaryColor = "#242166";
    return (
        <Modal
            title={
                <Title level={4} style={{ margin: 0, color: secondaryColor }}>
                    <PrinterOutlined style={{ marginRight: 8 }} />
                    Attestation CEDEAO
                </Title>
            }
            open={modalCEDEAOAttOpen}
            onCancel={() => {
                onTabsChange("1");
                setModalCEDEAOAttOpen(false);
            }}
            footer={null}
            width={1200}
            centered
            bodyStyle={{ padding: "24px" }}
            zIndex={2000}
        >
            {
                contrat?.engins?.map((eng, id) => (
                    <div key={id}>
                        <div className="container" justify="center" >
                            <div
                                className="grid-item"
                                lg={12}
                                ref={printedCEDEAOAttestation}
                            >
                                <div>
                                    {printingCEDEAOAttestation ?
                                        <AttestationCEDEAOToPrint
                                            contrat={contrat}
                                            engin={eng}
                                        /> :
                                        <AttestationCEDEAO
                                            contrat={contrat}
                                            engin={eng}
                                        />
                                    }

                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                </div>
                            </div>
                        </div>
                        {!eng.numeroAttestation || attestationDamaged ? <>
                            <InputNumber
                                style={{
                                    width: 200,
                                }}
                                placeholder="Numéro d'attestation"
                                value={numeroAttestation}
                                onChange={(v) => {
                                    setNumeroAttestation(v);
                                    console.log(v);
                                }}
                                formatter={(value) =>
                                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                                }
                                parser={(value) =>
                                    value.replace(/\s/g, "")
                                }
                            />
                            <br />
                            <br />
                            <Button
                                onClick={() => {
                                    setPrintingCEDEAOAttestation(true);
                                    console.log(
                                        "nA: ",
                                        numeroAttestation
                                    );
                                    // if (
                                    //   numeroAttestation.length < 4
                                    // ) {
                                    //   toast.error(
                                    //     "Veuillez renseigner un numéro d'attestation valide"
                                    //   );
                                    // } else {
                                    attestationDamaged ? printingDamagedCEDEAOAttestation(eng) : attestationCEDEAOPrinting(eng);
                                    // }
                                }}
                                type="primary"
                                style={{
                                    background: "green",
                                }}
                                disabled={!regle || !rightsService("HCO007") || contrat?.suspendu || contrat?.resilie || contrat?.avenant?.code?.startsWith("RS") || contrat?.avenant?.code?.startsWith("SP")}
                            >
                                Imprimer
                            </Button>
                        </> :
                            <>
                                <Button
                                    onClick={() => {
                                        setPrintingCEDEAOAttestation(true);
                                        attestationCEDEAONonPrintedPrinting(eng);
                                    }}
                                    type="primary"
                                    style={{
                                        background: "gray",
                                        color: "white"
                                    }}
                                    disabled={!regle || !rightsService("HCO007")}
                                >
                                    Impression non effectuée
                                </Button>

                                <Button
                                    onClick={() => {
                                        setPrintingCEDEAOAttestation(true);
                                        attestationCEDEAODamagedPrinting(eng);

                                    }}
                                    type="primary"
                                    style={{
                                        background: "orange",
                                        color: "white"
                                    }}
                                    disabled={!regle || !rightsService("HCO007")}
                                >
                                    Attestation bourrée / endommagée
                                </Button>
                            </>}
                    </div>
                ))}

        </Modal>
    )
}

export default ImprimerAttestationCEDEAO
